import {defineNuxtPlugin} from '#app';
import posthog from 'posthog-js';
export default defineNuxtPlugin(nuxtApp => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return;
  }

  const runtimeConfig = useRuntimeConfig();
  const posthogClient = posthog.init(runtimeConfig.public.posthogPublicKey, {
    api_host: runtimeConfig.public.posthogHost || '"https://us.i.posthog.com"',
    capture_pageview: false, // we add manual pageview capturing below
    loaded: posthog => {
      // if (import.meta.env.MODE === 'development') posthog.debug();
    },
  });

  // Make sure that pageviews are captured with each route change
  const router = useRouter();
  router.afterEach((to, from) => {
    nextTick(() => {
      posthog.capture('$pageview', {
        current_url: to.fullPath,
      });

      if (from.fullPath !== to.fullPath) {
        posthog.capture('$pageleave', {
          current_url: from.fullPath,
        });
      }
    });
  });

  return {
    provide: {
      posthog: () => posthogClient,
    },
  };
});
